import vxlColors from 'shared/styles/color/core';

const expressive = {
  sky: vxlColors.core.expressive.sky[500],
  skyHover: vxlColors.core.expressive.sky[600],
  skyPressed: vxlColors.core.expressive.sky[700],
  seafoam: vxlColors.core.expressive.seafoam[500],
  mint: vxlColors.core.expressive.mint[500],
  forest: vxlColors.core.expressive.forest[500],
  forestHover: vxlColors.core.expressive.forest[400],
  forestPressed: vxlColors.core.expressive.forest[300],
  orchid: vxlColors.core.expressive.orchid[500],
  orchidHover: vxlColors.core.expressive.orchid[600],
  orchidPressed: vxlColors.core.expressive.orchid[700],
  lavender: vxlColors.core.expressive.lavender[500],
  varoPurple: vxlColors.core.expressive.varoPurple[500],
  varoPurpleHover: vxlColors.core.expressive.varoPurple[600],
  varoPurplePressed: vxlColors.core.expressive.varoPurple[700],
  eggplant: vxlColors.core.expressive.eggplant[500],
  blush: vxlColors.core.expressive.blush[500],
  blushHover: vxlColors.core.expressive.blush[600],
  blushPressed: vxlColors.core.expressive.blush[700],
  coral: vxlColors.core.expressive.coral[500],
  sunset: vxlColors.core.expressive.sunset[500],
  wine: vxlColors.core.expressive.wine[500],
  sand: vxlColors.core.expressive.sand[500],
  sandHover: vxlColors.core.expressive.sand[600],
  sandPressed: vxlColors.core.expressive.sand[700],
  light: vxlColors.core.expressive.light[500],
  lightHover: vxlColors.core.expressive.light[600],
  lightPressed: vxlColors.core.expressive.light[700],
  lime: vxlColors.core.expressive.lime[500],
  limeHover: vxlColors.core.expressive.lime[600],
  limePressed: vxlColors.core.expressive.lime[700],
  earth: vxlColors.core.expressive.earth[500],
};

export default expressive;
